import {
  DashboardPage,
  UnderMaintenancePage,
  LoginPage,
  ProfilePage,
  NotFoundPage,
  ServerErrorPage,
  CustomerPage,
  SupplierPage,
  ProductPage,
  PrintInvoicePage,
  Master,
  TenantEntryPage,
  MaterialPage,
  PosPage,
  AiAssistantPage,
  SalePage,
  PurchasePage,
  StockReportPage,
  StockOpnamePage,
  InventoryInsightPage,
  StockHistoryPage,
  StockTransferPage,
  FinanceOverviewPage,
  ReportIncomePage,
  ReportExpensePage,
  ReportReceivablePage,
  ReportPayablePage,
  CashBankPage,
  OperationalExpensePage,
  FixedAssetPage,
  ActivityLogPage,
} from "../pages";
import { FullLayout, DashboardLayout, POSLayout } from "../layouts";
import PATH_URL from "./path";
import SellerStockPage from "../pages/SellerStockPage";

export const routes = [
  { path: PATH_URL.ACTIVITY_LOG, element: ActivityLogPage, needAuthenticated: true, layout: DashboardLayout, requiredPermissions: ["view-activity-logs"] },
  { path: PATH_URL.SELLER_STOCK, element: SellerStockPage, needAuthenticated: true, layout: DashboardLayout, requiredPermissions: ["view-seller-stocks"] },
  {
    path: PATH_URL.LOGIN,
    element: LoginPage,
    needAuthenticated: false,
    exact: true,
    layout: FullLayout,
  },
  {
    path: PATH_URL.LANDING,
    element: TenantEntryPage,
    needAuthenticated: false,
    exact: true,
    layout: FullLayout,
  },
  {
    path: PATH_URL.DASHBOARD,
    element: DashboardPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-dashboard"],
  },
  {
    path: PATH_URL.PROFILE,
    element: ProfilePage,
    needAuthenticated: true,
    layout: DashboardLayout,
  },
  {
    path: PATH_URL.MASTER_STORES,
    element: Master.StorePage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-stores"],
  },
  {
    path: PATH_URL.MASTER_OUTLETS,
    element: Master.OutletPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-outlets"],
  },
  {
    path: PATH_URL.MASTER_ACCOUNTS,
    element: Master.AccountPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-users"],
  },
  {
    path: PATH_URL.MASTER_UNITS,
    element: Master.UnitPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-units"],
  },
  {
    path: PATH_URL.MASTER_CATEGORIES,
    element: Master.CategoryMasterPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-products", "view-materials"],
  },
  {
    path: PATH_URL.MASTER_CATEGORY_TYPES,
    element: Master.CategoryTypePage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-products", "view-materials"],
  },
  {
    path: PATH_URL.MASTER_PRODUCT_CATEGORIES,
    element: Master.ProductCategoryPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-products"],
  },
  {
    path: PATH_URL.MASTER_MATERIAL_CATEGORIES,
    element: Master.MaterialCategoryPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-materials"],
  },
  {
    path: PATH_URL.MASTER_ROLES,
    element: Master.RolePage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-roles"],
  },
  {
    path: PATH_URL.MASTER_PERMISSIONS,
    element: Master.PermissionPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-permissions"],
  },
  {
    path: PATH_URL.MASTER_INVITATION_PACKAGES,
    element: UnderMaintenancePage,
    needAuthenticated: true,
    layout: DashboardLayout,
  },
  {
    path: PATH_URL.MASTER_INVITATION_SERVICES,
    element: UnderMaintenancePage,
    needAuthenticated: true,
    layout: DashboardLayout,
  },
  {
    path: PATH_URL.MASTER_INVITATION_SONGS,
    element: UnderMaintenancePage,
    needAuthenticated: true,
    layout: DashboardLayout,
  },
  {
    path: PATH_URL.MASTER_INVITATION_TAGS,
    element: UnderMaintenancePage,
    needAuthenticated: true,
    layout: DashboardLayout,
  },
  {
    path: PATH_URL.MASTER_INVITATION_TEMPLATES,
    element: UnderMaintenancePage,
    needAuthenticated: true,
    layout: DashboardLayout,
  },
  {
    path: PATH_URL.MASTER_REGEION_PROVINCES,
    element: Master.ProvincePage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-region"],
  },
  {
    path: PATH_URL.MASTER_REGEION_DISTRICTS,
    element: Master.DistrictPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-region"],
  },
  {
    path: PATH_URL.MASTER_REGEION_CITIES,
    element: Master.CityPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-region"],
  },
  {
    path: PATH_URL.MASTER_REGEION_VILLAGES,
    element: Master.VillagePage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-region"],
  },
  {
    path: PATH_URL.CUSTOMER,
    element: CustomerPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-customers"],
  },
  {
    path: PATH_URL.SUPPLIER,
    element: SupplierPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-suppliers"],
  },
  {
    path: PATH_URL.PURCHASE,
    element: PurchasePage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-purchases"],
  },
  {
    path: PATH_URL.MATERIAL,
    element: MaterialPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-materials"],
  },
  {
    path: PATH_URL.STOCK_REPORT,
    element: StockReportPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-stock-reports", "view-stock-opnames"],
  },
  {
    path: PATH_URL.STOCK_OPNAME,
    element: StockOpnamePage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-stock-opnames"],
  },
  {
    path: PATH_URL.INVENTORY_INSIGHT,
    element: InventoryInsightPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-stock-reports", "view-stock-opnames"],
  },
  {
    path: PATH_URL.STOCK_HISTORY,
    element: StockHistoryPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-stock-reports", "view-stock-opnames"],
  },
  {
    path: PATH_URL.STOCK_TRANSFER,
    element: StockTransferPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-stock-transfers"],
  },
  {
    path: PATH_URL.PRODUCTION,
    element: UnderMaintenancePage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-productions"],
  },
  {
    path: PATH_URL.PRODUCT,
    element: ProductPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-products"],
  },
  {
    path: PATH_URL.POS,
    element: PosPage,
    needAuthenticated: true,
    layout: POSLayout,
    requiredPermissions: ["view-pos"],
  },
  {
    path: PATH_URL.AI_ASSISTANT,
    element: AiAssistantPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-ai-assistant"],
  },
  {
    path: PATH_URL.SALE,
    element: SalePage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-sales", "view-own-sales"],
  },
  {
    path: PATH_URL.CASH_BANK,
    element: CashBankPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-cash-bank"],
  },
  {
    path: PATH_URL.OPERATIONAL_EXPENSE,
    element: OperationalExpensePage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-operational-expenses"],
  },
  {
    path: PATH_URL.FIXED_ASSET,
    element: FixedAssetPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-fixed-assets"],
  },
  {
    path: PATH_URL.REPORT,
    element: FinanceOverviewPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-reports"],
  },
  {
    path: PATH_URL.FINANCE,
    element: FinanceOverviewPage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-reports"],
  },
  {
    path: PATH_URL.REPORT_INCOME,
    element: ReportIncomePage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-reports", "view-sales-reports"],
  },
  {
    path: PATH_URL.REPORT_RECEIVABLE,
    element: ReportReceivablePage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-reports"],
  },
  {
    path: PATH_URL.REPORT_PAYABLE,
    element: ReportPayablePage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-reports"],
  },
  {
    path: PATH_URL.REPORT_EXPENSE,
    element: ReportExpensePage,
    needAuthenticated: true,
    layout: DashboardLayout,
    requiredPermissions: ["view-reports"],
  },
  {
    path: PATH_URL.TESTING_PRINT_INVOICE,
    element: PrintInvoicePage,
    needAuthenticated: true,
    layout: FullLayout,
    requiredPermissions: ["view-sales", "view-own-sales"],
  },
  {
    path: PATH_URL.NOT_FOUND,
    element: NotFoundPage,
    needAuthenticated: false,
    layout: FullLayout,
  },
  {
    path: PATH_URL.SERVER_ERROR,
    element: ServerErrorPage,
    needAuthenticated: true,
    layout: FullLayout,
  },
  {
    path: PATH_URL.UNDER_MAINTENANCE,
    element: UnderMaintenancePage,
    needAuthenticated: true,
    layout: FullLayout,
  },
];
